import { Button, ButtonProps } from '@chakra-ui/react';

interface SuccessButtonProps extends ButtonProps {
  children: string;
  sx?: React.CSSProperties;
}

const SuccessButton: React.FC<SuccessButtonProps> = ({
  children,
  sx,
  ...rest
}) => {
  return (
    <Button
      sx={{
        background: 'green.500',
        border: '1px solid #30A134 ',
        boxShadow: 'box-shadow: inset 0px 2px 0px rgba(234, 234, 234, 0.25)',
        height: '48px',
        borderRadius: '12px',
        color: '#fff',
        fontWeight: '400',
        lineHeight: '144%',
        letterSpacing: '-0.12px',
        '&:disabled': {
          color: 'ash.600',
          opacity: 0.8,
        },
        '&:hover': {
          background: 'green.600',
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default SuccessButton;
